var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { IsArray, IsBoolean, IsDate, IsInt, IsOptional, IsString, IsUUID } from 'class-validator';
export class SlotDto {
    start;
    end;
    duration;
    treatmentId;
    therapistId;
    therapistName;
    roomId;
    deviceIds = [];
    violates14DayRule;
    weekNumber;
    combinedTreatmentIds;
}
__decorate([
    Type(() => Date),
    IsDate(),
    __metadata("design:type", Date)
], SlotDto.prototype, "start", void 0);
__decorate([
    Type(() => Date),
    IsDate(),
    __metadata("design:type", Date)
], SlotDto.prototype, "end", void 0);
__decorate([
    IsInt(),
    __metadata("design:type", Number)
], SlotDto.prototype, "duration", void 0);
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], SlotDto.prototype, "treatmentId", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", Object)
], SlotDto.prototype, "therapistId", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], SlotDto.prototype, "therapistName", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], SlotDto.prototype, "roomId", void 0);
__decorate([
    IsArray(),
    IsUUID('4', { each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], SlotDto.prototype, "deviceIds", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], SlotDto.prototype, "violates14DayRule", void 0);
__decorate([
    IsInt(),
    __metadata("design:type", Number)
], SlotDto.prototype, "weekNumber", void 0);
__decorate([
    IsArray(),
    IsUUID('4', { each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], SlotDto.prototype, "combinedTreatmentIds", void 0);
//# sourceMappingURL=slot.dto.js.map